  (function() {
    const scrollToSection = sessionStorage.getItem('scrollToSection');
    
    if (scrollToSection) {
      sessionStorage.removeItem('scrollToSection');
      
      const scrollToTarget = () => {
        const targetElement = document.getElementById(scrollToSection);
        
        if (targetElement) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const elementPosition = targetElement.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - 100;
              
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            });
          });
        }
      };
      
      if (document.readyState === 'complete') {
        scrollToTarget();
      } else {
        window.addEventListener('load', scrollToTarget);
      }
    }
  })();